import type { Mutation } from 'vuex'
import type { State, UsersDetailType } from './state'

import actionTypes from './actionTypes'

const mutations: { [actionTypes: string]: Mutation<State> } = {
  [actionTypes.SET_FOLDER_INFO_DETAIL]: (state: State, item: any) => {
    state.detail = [...item]
  },
  [actionTypes.SET_FOLDER_INFO_DETAIL_SAME]: (state: State, item: any) => {
    state.detailSame = [...item]
  },

  [actionTypes.PUT_FOLDER_INFO_DETAIL]: (state: State, status: number) => {
    state.detailStatus = status
  },

  [actionTypes.SET_FOLDER_INFO_USERS_DETAIL]: (state: State, item: any) => {
    state.usersDetail = [...item]
  },

  [actionTypes.SET_FOLDER_INFO_USERS_DETAIL_N]: (state: State, item: any) => {
    state.usersDetailN = [...item]
  },
  [actionTypes.SET_FOLDER_INFO_USERS_DETAIL_ALL]: (state: State, item: any) => {
    state.usersDetailAll = [...item]
    console.log(state.usersDetailAll)
  },
  [actionTypes.SET_FOLDER_INFO_USERS_DETAIL_ALL_SAME]: (state: State, item: any) => {
    state.usersDetailAllSame = [...item]
  },
  [actionTypes.SET_FOLDER_INFO_DETAIL_CHECKED_LIST]: (state: State, item: any) => {
    // クリア
    if (item == 'N') {
      state.checkedList = []
    } else {
      if (item.checked) {
        state.checkedList.push(item)
      }
    }
  },

  [actionTypes.SET_FOLDER_INFO_EDIT_USERS_LIST]: (state: State, val: any) => {
    if (state.editUsersList.length > 0) {
      let num = true
      state.editUsersList.forEach((item: any, index: any) => {
        if (item.user_id == val.user_id) {
          num = false
          state.editUsersList.splice(index, 1)
        }
      })
      if (num) {
        state.editUsersList.push(val)
      }
    } else {
      state.editUsersList.push(val)
    }
  },

  [actionTypes.SET_FOLDER_INFO_USERS_SELECT_LIST]: (state: State, val: any) => {
    if (val.add) {
      if (state.usersDetailN.length > 0) {
        state.usersDetailN.forEach((item: any, index: number) => {
          if (item.user_id == val.item.user_id) {
            state.usersDetailN.splice(index, 1)
            state.usersDetail.push(item)
          }
        })
      }
    } else {
      if (state.usersDetail.length > 0) {
        state.usersDetail.forEach((item: any, index: number) => {
          if (item.user_id == val.item.user_id) {
            state.usersDetail.splice(index, 1)
            state.usersDetailN.push(item)
          }
        })
      }
    }
  },

  //利用者一覧追加
  [actionTypes.PUT_FOLDER_INFO_USERS_DETAIL]: (state: State, val: UsersDetailType) => {
    let newData = {} as UsersDetailType
    state.usersDetailAll.forEach((item: UsersDetailType) => {
      if (item.user_id === val.user_id) {
        item.display_in_list = val.display_in_list
        newData = item
      }
    })

    let isRepeated = false
    state.usersDetail.forEach((item: UsersDetailType) => {
      if (item.user_id === val.user_id) {
        item.display_in_list = val.display_in_list
        isRepeated = true
      }
    })

    //利用者一覧に追加後、選択リストから追加したデータを削除する。
    const tempData = state.usersDetailN
    state.usersDetailN = tempData.filter(
      (item: UsersDetailType) => item.user_id !== val.user_id
    )

    //存在しない　或いは　重複するデータは一覧に追加しないように。
    if (val.user_id && !isRepeated) {
      state.usersDetail.push(newData)
    }
  },

  //利用者一覧削除
  [actionTypes.DELETE_FOLDER_INFO_USERS_DETAIL]: (state: State, val: UsersDetailType) => {
    let deleteData = {} as UsersDetailType

    state.usersDetailAll.forEach((item: UsersDetailType) => {
      if (item.user_id === val.user_id) {
        deleteData = item
        item.display_in_list = val.display_in_list
      }
    })

    const tempData = state.usersDetail
    tempData.forEach((item: UsersDetailType) => {
      if (item.user_id === val.user_id) {
        item.display_in_list = val.display_in_list
      }
    })
    //利用者一覧表示用データから削除されたものを非表示する。
    state.usersDetail = tempData.filter((item: UsersDetailType) => item.display_in_list)
    //利用者検索選択リストに削除されたデータを追加する。
    state.usersDetailN.forEach((item: UsersDetailType) => {
      if (item.user_id === val.user_id) {
        item = deleteData
      }
    })

    state.usersDetailN.push(deleteData)
  },

  [actionTypes.SET_MODAL_USER_INFO_ADD_ACTIVED]: (state: State, status: boolean) => {
    state.modalUserInfoAddActived = status
  },
  //apiから取得する利用者一覧データ
  [actionTypes.SET_ORIGIN_USER_INFO_LISTS]: (
    state: State,
    data: Array<UsersDetailType>
  ) => {
    state.originUserInfoLists = [...data]
  },
  //表示用に変換した利用者一覧データ バックアップ用
  [actionTypes.SET_BACKUP_USER_INFO_LISTS]: (
    state: State,
    data: Array<UsersDetailType>
  ) => {
    state.backupUserInfoLists = [...data]
  },
  //表示用に変換した利用者一覧データ 表示用
  [actionTypes.SET_DISPLAY_USER_INFO_LISTS]: (
    state: State,
    data: Array<UsersDetailType>
  ) => {
    state.displayUserInfoLists = [...data]
  },
  //利用者一覧　テーブル表示用
  [actionTypes.SET_TABLE_USER_INFO_LISTS]: (
    state: State,
    data: Array<UsersDetailType>
  ) => {
    state.tableUserInfoLists = [...data]
  },
  //検索欄に入力ある場合、検索結果を表示用利用者一覧データ
  [actionTypes.SET_SEARCH_USER_INFO_LISTS]: (
    state: State,
    data: Array<UsersDetailType>
  ) => {
    state.searchserUserInfoLists = [...data]
  },
}

export default mutations
